import type { ScheduledActionResponse } from '@store/generated/appointments';

/**
 * Maps scheduled action status to UI-friendly status strings
 */
export function mapScheduledActionStatus(
  status: string,
  actionType: 'appointment_form' | 'appointment_reminder',
): string {
  switch (status) {
    case 'pending':
      return 'scheduled'; // Waiting for scheduled time
    case 'processing':
      return 'sending'; // Currently being processed
    case 'completed':
      return 'sent'; // Both forms and reminders show as "sent"
    case 'failed':
      return 'failed'; // Action failed
    case 'cancelled':
      return 'canceled'; // Action was canceled
    default:
      return 'configured'; // Fallback status
  }
}

/**
 * Finds a scheduled action by rule ID
 */
export function findScheduledActionByRuleId(
  scheduledActions: ScheduledActionResponse[] | null | undefined,
  ruleId: string,
): ScheduledActionResponse | undefined {
  if (!scheduledActions) return undefined;
  return scheduledActions.find(action => action.rule_id === ruleId);
}

/**
 * Formats a timestamp for display
 */
export function formatActionTimestamp(timestamp: string | null | undefined): string {
  if (!timestamp) return '';

  try {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return timestamp;
  }
}
